import * as gtm from './gtm';
export { gtm };